import { PayloadAction } from '@reduxjs/toolkit';
import { CommonResponse } from '../../../../models';
import { call, put, takeLatest } from 'redux-saga/effects';
import menuStructureSettingService from './menuStructureSettingService';
import { menuStructureSettingActions } from './menuStructureSettingSlice';
import { MenuStructureSetting } from '../models';
import { toast } from 'react-toastify';

function* fetchMenuStructureSetting(action: PayloadAction<{ id: string }>) {
  try {
    const response: CommonResponse<MenuStructureSetting> = yield call(
      menuStructureSettingService.getItem,
      action.payload.id
    );
    yield put(menuStructureSettingActions.fetchMenuStructureSettingSuccess(response));
  } catch (error: any) {
    yield put(menuStructureSettingActions.fetchMenuStructureSettingFailed(error.response));
    const errorMessage = error.response.data.message;
    const unitErrors = errorMessage.unit_code_errors;
    const rateErrors = errorMessage.rate_errors;
    const unitErrorMesage =
      unitErrors.length === 0 ? (
        ''
      ) : (
        <>
          <div>
            {' '}
            <b>補助単位コード３</b>が未登録です。データを確認してください。
          </div>
          {unitErrors.map((unitError: any) => (
            <div>{`構成コード：${unitError.code}　名称：${unitError.name}`}</div>
          ))}
        </>
      );
    const rateErrorsMessage =
      rateErrors.length === 0 ? (
        ''
      ) : (
        <>
          <div>
            <b>補助単位換算率３</b>が未登録です。データを確認してください。
          </div>
          {rateErrors.map((rateError: any) => (
            <div>{`構成コード：${rateError.code}　名称：${rateError.name}`}</div>
          ))}
        </>
      );
    toast.error(
      <>
        {unitErrorMesage}
        <br />
        {rateErrorsMessage}
      </>,
      {
        autoClose: 15000,
        closeOnClick: false,
        draggable: false,
      }
    );
  }
}

export default function* menuStructureSettingSaga() {
  yield takeLatest(menuStructureSettingActions.fetchMenuStructureSetting.type, fetchMenuStructureSetting);
}
